// @flow
import React from 'react';
import { useParams } from 'react-router-dom';

import { useUpdateEstimateMutation } from '../../service-definitions/estimates';
import { useEstimateVersion } from '../../custom-hooks/useEstimateVersion';
import { APPLY_SYSTEM_GENERATED_CNBC_CONFIG } from '../common/sgcnbc/constants';
import { CheckBoxField } from '../../formik-utils/FormFields';
import { toastError } from '../presentational/notifications/utils';

export const CNBCAutomationToggleContainer = ({ readOnlyMode }) => {
  const { estimateId } = useParams();
  const [updateEstimateDetails] = useUpdateEstimateMutation();
  const estimateVersion = useEstimateVersion();
  const { backendFieldName, displayName } = APPLY_SYSTEM_GENERATED_CNBC_CONFIG;

  return (
    <CheckBoxField
      disabled={readOnlyMode}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      onChange={async (event, value, setFieldValue, setFieldTouched, values, checked) => {
        const payload = {
          [backendFieldName]: checked,
          estimate_version: estimateVersion,
        };

        const { error } = await updateEstimateDetails({
          estimateId: estimateId,
          payload,
        });

        if (error) {
          toastError(error);
        }
      }}
    />
  );
};
